// extracted by mini-css-extract-plugin
export default {"info":"ShippingTime_info__-yMMR","is--express":"ShippingTime_is--express__xP3jG"};